import { AccordionPanel } from '@faststore/ui'
import React from 'react'

import { DepartmentContainer } from '../../../components/DepartmentContainer'
import { AllCategoriesContainer } from '../AllCategoriesContainer/AllCategoriesContainer'
import './accordion-content.scss'

interface AccordionContentProps {
  couponsLoading: boolean
  hasActiveCoupons: boolean
  allCategoriesVisibility: boolean
  setAllCategoriesVisibility: (allCategoriesVisibility: boolean) => void
  departament?: {
    slug: string
    title: string
    categorie: {
      title: string
      slug: string
      subcategorie: {
        title: string
        slug: string
      }[]
    }[]
  }[]
  position?: number
  setPosition: (position: number) => void
  closeMenu: () => void
  currentCategorie: string
  setCurrentCategorie: (currentCategorie: string) => void
  subCategoriePosition: number
  setSubCategoriePosition: (postion: number) => void
}
export const AccordionContent = ({
  couponsLoading,
  hasActiveCoupons,
  departament,
  position,
  allCategoriesVisibility,
  setAllCategoriesVisibility,
  setPosition,
  closeMenu,
  currentCategorie,
  setCurrentCategorie,
  setSubCategoriePosition,
  subCategoriePosition,
}: AccordionContentProps) => {
  if (!departament) {
    return null
  }

  return (
    <AccordionPanel className="acordion-panel">
      <DepartmentContainer
        couponsLoading={couponsLoading}
        hasActiveCoupons={hasActiveCoupons}
        closeMenu={closeMenu}
        position={position}
        setPosition={setPosition}
        setSecondVisibleColumn={setAllCategoriesVisibility}
      />
      <AllCategoriesContainer
        subCategoriePosition={subCategoriePosition}
        setSubCategoriePosition={setSubCategoriePosition}
        setSecondVisibleColumn={setAllCategoriesVisibility}
        setCurrentCategorie={setCurrentCategorie}
        currentCategorie={currentCategorie}
        closeMenu={closeMenu}
        position={position}
        allCategoriesVisibility={allCategoriesVisibility}
      />
    </AccordionPanel>
  )
}
